import * as React from 'react';
import {Switch, Route} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

import {setBodyId} from '../../../dom';

import {SetupPage} from '../setup-page';

import {CancelPage} from './cancel/cancel-page';
import {ChurnPage} from './churn/churn-page';
import {Home} from './home';
import {Manage} from './manage';
import {mountPauseForm} from './pause-cancel-flow/mount-pause-form';
import {PausePage} from './pause-cancel-flow/pause-page';
import {PauseRequestedPage} from './pause-cancel-flow/pause-requested-page';
import {PausedPage} from './pause-cancel-flow/paused-page';
import {RestoreRequestedPage} from './pause-cancel-flow/restore-requested-page';

export function BillingRoot(props: ContextRouter) {
    // Prevent mixpanel recording on sensitive pages
    mixpanel.stop_session_recording();

    React.useEffect(() => {
        setBodyClasses(props.location.pathname);
    }, [props.location.pathname]);

    return (
        <Switch>
            <Route
                path='/setup/billing/paused'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return <PausedPage />;
                }}
            />
            <Route
                path='/setup/billing/pause'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return <PausePage />;
                }}
            />
            <Route
                path='/setup/billing/pause-requested'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return <PauseRequestedPage />;
                }}
            />
            <Route
                path='/setup/billing/restore-requested'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return <RestoreRequestedPage />;
                }}
            />
            <Route
                path='/setup/billing/pause-form'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return (
                        <SetupPage
                            pageTitle='Billing'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountPauseForm}
                        />
                    );
                }}
            />
            <Route path='/setup/billing/cancel' exact={true} render={() => <CancelPage />} />
            <Route
                path='/setup/billing/goodbye'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('billing');

                    return (
                        <SetupPage
                            pageTitle='Billing'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/billing/expired'
                exact={true}
                render={(routeProps) => {
                    // todo test this and see what we can figure out
                    // @ts-expect-error
                    return <Home {...routeProps} isExpired={true} />;
                }}
            />
            <Route
                path='/setup/billing'
                exact={true}
                render={(routeProps) => {
                    // @ts-expect-error
                    return <Home {...routeProps} />;
                }}
            />
            <Route path='/setup/billing/churn' exact={true} render={() => <ChurnPage />} />
            <Route
                path={[
                    '/setup/billing/sales',
                    '/setup/billing/marketing',
                    '/setup/billing/engagement',
                    '/setup/billing/add-ons',
                    '/setup/billing/review',
                    '/setup/billing/success',
                ]}
                exact={true}
                render={(routeProps) => {
                    return <Manage {...routeProps} />;
                }}
            />
        </Switch>
    );
}

const baseBodyClasses = ['manage', 'page', 'settings'];

function setBodyClasses(pathname: string): void {
    const body = document.querySelector('body');

    if (!body) return;

    if (pathname.includes('/setup/billing/cancel')) {
        body.className = baseBodyClasses.concat(['page-billing']).join(' ');
    } else if (pathname.includes('/setup/billing/goodbye')) {
        body.className = baseBodyClasses.concat(['signup-goodbye']).join(' ');
    } else if (pathname.includes('/setup/billing/thanks')) {
        body.className = baseBodyClasses.concat(['signup-thank-you']).join(' ');
    } else if (pathname.includes('/setup/billing/pause')) {
        body.className = baseBodyClasses.concat(['page-billing']).join(' ');
    } else if (pathname.includes('/setup/billing')) {
        body.className = baseBodyClasses.concat(['page-billing']).join(' ');
    }
}
